import con from '../../../../connection';
var path = '/occupations';
var occupations = function (url) { return function () { return ({
    // 職種一覧取得
    get: function () { return con.get(url + path, {}); },
}); }; };
export default occupations;
